import styles from "./LoadingApp.module.scss"

import React from "react"

import { Icon } from "antd"

function LoadingApp() {
  return <Icon type="loading" className={styles.icoLoading} />
}

export default LoadingApp
